module.exports = __webpack_public_path__ + "img/Skirt-Back-B8-Da.b3973ded.png";